// Module
var code = `<div>
	<button type="button" class="btn btn-secondary dropdown-toggle" data-bind="text: buttonText"></button>
</div>
`;
// Exports
export default code;